// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../viewports.css\"","desktop":"1024px","form-editor-container":"grid_form-editor-container__oxynn","form-editor-content":"grid_form-editor-content___RIcm"};